import { clearAuthKeysFromLocalstorage } from './localStorage'

export const estaEmFrame = () => {
  try {
    return window.self !== window.top
  } catch (error) {
    return true
  }
}

export const limparSessaoHerdadaEmFrame = () => {
  if (!estaEmFrame()) return false
  clearAuthKeysFromLocalstorage()
  return true
}
